import ListEquipmentFilterMobile from "./ListEquipmentFilterMobile";

export default ListEquipmentFilterMobile;
